module.exports = "../fonts/simple-line-icons_emotsmile.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/simple-line-icons_emotsmile.svg
// module id = 294
// module chunks = 0